import React, { useState, Fragment } from 'react';
import QuestionContext from 'apps/journey/context/question-context';
import { resolve } from 'library/helpers/path-resolver';
import * as Colorado from 'apps/journey/forms/components/college-in-colorado/styled';
import Tooltip from 'library/components/tooltip';
import Information from 'library/icons/info-icon.svg';
import { ShimmyValue } from 'library/components/shimmy';
import { string, array } from 'prop-types';

const CollapsablePanel = ({title, data = []}) => {
  const [collapsed, setCollapsed] = useState(true);

  const listOnly = data.filter(({date}) => !!date ).length == 0;

  const mapData = () => data.map(({name, date}, i) => (
    listOnly ? (
      <Colorado.ListItem key={i}>
        {name}
      </Colorado.ListItem>
    ) :
      (
        <Colorado.ItemWithDate key={i}>
          <h4>
            {name}
          </h4>
          <span>
            {date}
          </span>
        </Colorado.ItemWithDate>
      )
  ));

  return data.length > 0 ? (
    <Fragment>
      <Colorado.CollapsableHeader onClick={() => setCollapsed(!collapsed)}>
        <h3>{title}</h3>
        <Colorado.CollapsableCaret collapsed={collapsed} />
      </Colorado.CollapsableHeader>
      <Colorado.CollegeCollapsable listOnly={listOnly} collapsed={collapsed}>
        <div className={'collapsableBody'}>
          {!collapsed && data.length > 0 && mapData()}
        </div>
      </Colorado.CollegeCollapsable>
    </Fragment>
  ) : <Fragment />;
};

CollapsablePanel.propTypes = {
  title: string,
  data: array
};

const CollegeInColorado = () => {
  const [activeToolTip, setActiveToolTip] = useState(false);
  const panelConfig = [
    {title: 'Saved Careers', path: 'saved_careers'},
    {title: 'Saved Clusters', path: 'saved_clusters'},
    {title: 'Saved Pathways', path: 'saved_pathways'},
    {title: 'Suggested Career Clusters', path: 'suggested_career_clusters'},
    {title: 'Transferable Skills', path: 'transferable_skills'},
  ];

  const mapPanels = (user_pool) => panelConfig.map(({title, path}, i) => {
    const jsonParsedData = JSON.parse(resolve(user_pool, path, '[]'));
    const data = jsonParsedData === null ? [] : jsonParsedData;
    return (
      <CollapsablePanel key={i} title={title} data={data} />
    );
  });
  const tooltipText = 'We found some activities you previously completed using College in Colorado. It will live here for now so you can always reference it!';

  return (
    <QuestionContext.Consumer>
      {({user_pool}) => (
        <Colorado.PanelBody>
          <ShimmyValue namespace='tooltip_placeholder'>
            <Tooltip
              modal={
                <p style={{ margin: 0 }}>{tooltipText}</p>
              }
              onlyShowOne
              activeToolTip={activeToolTip}
              hideOnScroll
              direction={'bottom'} >
              <Information onClick={() => setActiveToolTip(!activeToolTip)} />
            </Tooltip>
          </ShimmyValue>
          {panelConfig.length > 0 && mapPanels(user_pool)}
        </Colorado.PanelBody>
      )}
    </QuestionContext.Consumer>
  );
};

export default CollegeInColorado;
